const enTranslations = {
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    update: 'Update',
    delete: 'Delete',
    deleting: 'Deleting...',
    edit: 'Edit',
    view: 'View',
    download: 'Download',
    upload: 'Upload',
    share: 'Share',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    actions: 'Actions',
    close: 'Close',
    apply: 'Apply',
    clearAll: 'Clear All',
    retry: 'Retry',
    select: 'Select',
    selectAll: 'Select All',
    moreCount: '+{{count}} more',
    noData: 'No data available',
    noResults: 'No results found',
    all: 'All',
    more: 'More',
    less: 'Less',
    important: 'Important',
    language: 'Language',
    goHome: 'Go Home',
    refresh: 'Refresh',
    enabled: 'Enabled',
    disabled: 'Disabled',
    currentSession: 'Current Session',
    lastActivity: 'Last Activity',
    expires: 'Expires',
    registeredAt: 'Registered At',
    lastUsed: 'Last Used',
    comingSoon: 'Coming soon',
    noGroups: 'No groups',
    unknown: 'Unknown',
    userInfoNotAvailable: 'User information not available. Please login again.',
    expand: 'Expand',
    collapse: 'Collapse',
  },

  // Navigation
  navigation: {
    dashboard: 'Dashboard',
    documents: 'Documents',
    search: 'Search',
    uploadDocument: 'Upload Document',
    drbfm: 'DRBFM Analysis',
    verification: 'Design Verification',
    cadViewer: '3D CAD Viewer',
    settings: 'Settings',
    help: 'Help',
    profile: 'Profile',
    logout: 'Logout',
    toggleSidebar: 'Toggle sidebar',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    totalDocuments: 'Total Documents',
    recentUploads: 'Recent Uploads',
    totalViews: 'Total Views',
    activeUsers: 'Active Users',
    fromLastMonth: 'from last month',
    inLast7Days: 'in last 7 days',
    thisMonth: 'this month',
    currentlyOnline: 'currently online',
    recentDocuments: 'Recent Documents',
    viewAll: 'View All',
    trendingSearches: 'Trending Searches',
    lastNDays: 'Last {{days}} days',
    announcements: 'Announcements',
    noAnnouncements: 'No announcements at this time',
    searches: '{{count}} searches',
    announcementAuthor: 'Development team',
    announcementItems: {
      drbfmKnowledge: {
        title: 'Improved DRBFM related-knowledge citations',
        message: 'Review linked files, excerpts, and relevance in DRBFM failure-mode details.',
      },
      chatQuality: {
        title: 'Improved chat search and reference quality',
        message: 'Search result grouping, reference relevance, and grounded answers are more stable.',
      },
      auditOperations: {
        title: 'Expanded audit logs and operations observability',
        message: 'Key operation audit logs, anomaly detection, and admin CSV exports are now supported.',
      },
      helpRefresh: {
        title: 'Updated help and operation guides',
        message: 'Search, chat, DRBFM, CAD, and audit guidance now match the current feature set.',
      },
    },
  },

  // Documents
  documents: {
    title: 'Documents',
    uploadDocument: 'Upload Document',
    documentList: 'Document List',
    gridView: 'Grid View',
    listView: 'List View',
    searchPlaceholder: 'Search documents...',
    filters: 'Filters',
    applyFilters: 'Apply Filters',
    sortBy: 'Sort',
    sortOptions: {
      date: 'Date',
      name: 'Name',
      size: 'Size',
      category: 'Category',
    },
    sortOrder: {
      asc: 'asc',
      desc: 'desc',
    },
    noDocumentsFound: 'No documents found',
    tryAdjustingFilters: 'Try adjusting your filters or search query',
    generalCategory: 'General',
    deepAnalyzed: 'Deep analyzed',
    loadMore: 'Load more',
    resultsCount: '{{shown}} / {{total}} documents',
    shareDocument: 'Share Document',
    shareComingSoon: 'Sharing is currently under development.',

    // Document fields
    document: 'Document',
    category: 'Category',
    uploadedBy: 'Uploaded By',
    size: 'Size',
    modified: 'Modified',
    version: 'Version',

    // Filters
    filterBy: 'Filter by',
    categories: 'Categories',
    tags: 'Tags',
    fileTypes: 'File Types',
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    activeFilters: '{{count}} active filters',
    activeFilter: '{{count}} active filter',

    // Document Detail Page
    details: 'Details',
    versionHistory: 'Version History',
    permissions: 'Permissions',
    metadata: 'Metadata',
    department: 'Department',
    classification: 'Classification',
    retentionPeriod: 'Retention Period',
    lastModified: 'Last Modified',
    years: 'years',
    actions: 'Actions',
    preview: 'Preview',
    loadingPreview: 'Loading preview...',
    uploadNewVersion: 'Upload New Version',
    failedToLoad: 'Failed to load document',
    documentNotFound: 'Document not found',
    returnToDocuments: 'Return to Documents',
    analysisHistory: 'Analysis History',
    analysisHistoryView: {
      emptyTitle: 'This document does not have deep analysis history yet.',
      emptyDescription: 'Ask chat to run deep analysis for a selected document to record detailed technical analysis.',
      title: 'Analysis History ({{count}})',
      type: {
        deepTechnicalAnalysis: 'Deep technical analysis',
        summary: 'Summary',
        extraction: 'Data extraction',
      },
      createdBy: 'Created by: {{name}}',
      showContent: 'Show analysis content',
    },
    detailTabsAria: 'Document detail tabs',
    previewUnavailableForType: 'Preview is not available for {{type}}',
    previewLoadFailed: 'Failed to load preview',
    previewLoadFailedWithStatus: 'Failed to load preview: {{status}}',
    previewLoadFailedWithStatusText: 'Failed to load preview: {{status}} {{statusText}}',
    fileTypeFallback: 'this file type',
    fileName: 'File Name',
    fileType: 'File Type',
    fileSize: 'File Size',
    status: 'Status',
    createdAt: 'Created At',
    reExtractMetadata: 'Re-extract Metadata',
    reExtractMetadataDescription: 'Use the LLM to regenerate metadata from the document. Select the fields you want to update.',
    regenerateTitle: 'Regenerate title',
    regenerateSummary: 'Regenerate summary',
    regenerateTags: 'Regenerate tags',
    reExtractingMetadata: 'Re-extracting metadata...',
    selectAtLeastOneMetadataField: 'Select at least one field.',
    metadataReExtractFailed: 'Failed to re-extract metadata.',
    extractedImagesTitle: 'Extracted Images & Drawings',
    itemCount: '({{count}} items)',
    imageAnalysisComplete: 'Image analysis is complete.',
    imageAnalysisFailed: 'Image analysis failed.',
    imagesAnalyzed: 'Analyzed {{count}} images.',
    imagesReanalyzed: 'Reanalyzed {{count}} images.',
    imagesExtracted: 'Extracted {{count}} images.',
    blueprintImagesExtracted: 'Extracted {{count}} drawing images.',
    imageReExtractFailed: 'Failed to re-extract images.',
    blueprintReExtractFailed: 'Failed to re-extract drawing images.',
    aiAnalyzing: 'AI analysis in progress...',
    analyzeAllImages: 'Analyze all images with AI',
    forceReanalyze: 'Reanalyze existing analysis results',
    extracting: 'Extracting...',
    reExtractImages: 'Re-extract images',
    reExtractAsBlueprint: 'Re-extract as drawings',
    imagesSelected: '{{count}} selected',
    selectTwoImages: 'Select two images.',
    selectAtLeastTwoImages: 'Select at least two images.',
    sequenceAnalysisMaxImages: 'Sequence analysis supports up to {{count}} images.',
    extractedImageAlt: 'Page {{page}}, Image {{index}}',
    imageLoadFailed: 'Unable to load image',
    imageFileNotFound: 'File not found',
    imagePageCaption: 'Page {{page}} - Image {{index}}',
    aiAnalysisResult: 'AI Analysis Result',
    analyzing: 'Analyzing...',
    reanalyze: 'Reanalyze',
    aiAnalysis: 'AI Analysis',
    noExtractedImages: 'No images have been extracted from this document.',
    documentPermissions: 'Document Permissions',
    versionHistoryFetchFailed: 'Failed to fetch version history',
    versionHistoryLoadFailed: 'Failed to load version history',
    noDescription: 'No description',
    noVersionHistory: 'No version history available',
    versionWithNumber: 'Version {{version}}',
    versionWithCurrent: 'Version {{version}} (Current)',
    currentVersion: 'Current',
    deepAnalysisCompleted: 'Deep analysis completed',
    deepTechnicalAnalysis: 'Deep Technical Analysis',
    createdBy: 'Created by: {{name}}',
    compare: 'Compare',
    restore: 'Restore',
    compareWithCurrent: 'Compare with Current',
    restoreThisVersion: 'Restore This Version',
    compareVersions: 'Compare Versions',
    versus: 'vs',
    versionComparisonComingSoon: 'Version comparison view will be implemented here',
    pdfLoadFailed: 'Failed to load PDF document',
    pdfSearchTooltip: 'Search (press N/P to navigate results)',
    toggleResultsList: 'Toggle results list',
    searchInDocument: 'Search in document...',
    pageResultPreview: 'Page {{page}}: {{text}}...',
    previousResultShortcut: 'Previous (P)',
    nextResultShortcut: 'Next (N)',
    imageComparison: {
      title: 'Image Comparison & Linked Analysis',
      type: 'Comparison Type',
      compareTwo: 'Compare two',
      sequenceAnalysis: 'Sequence analysis ({{count}} items)',
      selectImagesHint: 'Select images to start comparison or linked analysis',
      compareResultTitle: 'Image Comparison Analysis Result',
      sequenceResultTitle: 'Image Sequence Analysis Result',
      aiAnalyzingPleaseWait: 'AI analysis in progress. Please wait.',
      typeWithValue: 'Comparison type: {{type}}',
      resultLoadFailed: 'Failed to retrieve analysis result',
      types: {
        changes: 'Changes',
        evolution: 'Design Evolution',
        differences: 'Differences',
      },
    },
  },

  // File types
  fileTypes: {
    pdf: 'PDF',
    docx: 'Word Document',
    xlsx: 'Excel File',
    pptx: 'PowerPoint',
    other: 'Other',
  },

  // Time
  time: {
    justNow: 'just now',
    minutesAgo: '{{count}} minutes ago',
    hoursAgo: '{{count}} hours ago',
    daysAgo: '{{count}} days ago',
    weeksAgo: '{{count}} weeks ago',
    monthsAgo: '{{count}} months ago',
    yearsAgo: '{{count}} years ago',
    ago: '{{value}} ago',
  },

  // Auth
  auth: {
    login: 'Login',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset Password',
    tenantCode: 'Tenant Code',
    loginError: 'Login failed',
    invalidCredentials: 'Invalid email or password',
    // Login Page
    signInPrompt: 'Sign in to your account',
    signIn: 'Sign In',
    emailAddress: 'Email Address',
    tenantCodePlaceholder: 'e.g., ACME',
    emailPlaceholder: 'user@example.com',
    togglePasswordVisibility: 'Toggle password visibility',
    // Forgot Password Page
    forgotPasswordTitle: 'Forgot Password?',
    forgotPasswordDescription: "Enter your email address and tenant code. We'll send you a link to reset your password.",
    sendResetLink: 'Send Reset Link',
    backToLogin: 'Back to Login',
    checkYourEmail: 'Check Your Email',
    resetLinkSent: "We've sent a password reset link to",
    checkSpamFolder: "If you don't see the email, please check your spam folder.",
    // Reset Password Page
    resetPasswordTitle: 'Reset Your Password',
    resetPasswordDescription: 'Enter your new password below.',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    passwordResetSuccess: 'Password Reset Successful',
    passwordResetSuccessMessage: 'Your password has been successfully reset. You can now sign in with your new password.',
    goToLogin: 'Go to Login',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordRequirementsNotMet: 'Password does not meet the minimum security requirements.',
    invalidResetToken: 'Invalid or missing reset token. Please request a new password reset.',
    resetLinkExpired: 'Failed to reset password. The reset link may have expired.',
    // Password requirements
    passwordRequirements: 'Password Requirements:',
    minLength: 'At least 8 characters',
    hasUpperCase: 'One uppercase letter',
    hasLowerCase: 'One lowercase letter',
    hasNumber: 'One number',
    hasSpecial: 'One special character',
  },

  // Errors
  errors: {
    generic: 'An error occurred',
    notFound: 'Page not found',
    pageNotFoundDescription: "The page you are looking for doesn't exist or has been moved.",
    unauthorized: 'Unauthorized',
    forbidden: 'Access denied',
    serverError: 'Server error occurred',
    networkError: 'Network error occurred',
    authenticationRequired: 'Authentication is required. Please log in again.',
  },

  // Success messages
  success: {
    saved: 'Saved successfully',
    uploaded: 'Uploaded successfully',
    deleted: 'Deleted successfully',
    updated: 'Updated successfully',
    shared: 'Shared successfully',
  },

  // Confirmation
  confirmation: {
    deleteDocument: 'Are you sure you want to delete this document?',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
  },

  // Notifications
  notifications: {
    info: 'Info',
    warning: 'Warning',
    error: 'Error',
    success: 'Success',
  },

  // Session
  session: {
    expiredDueToInactivity: 'Your session has expired due to inactivity.',
    expiresSoon: 'Your session will expire in 5 minutes due to inactivity.',
    expired: 'Your session has expired. Please log in again.',
    extended: 'Session extended.',
  },

  // Pagination
  pagination: {
    page: 'Page',
    of: 'of',
    show: 'Show',
    showing: 'Showing',
    to: 'to',
    items: 'items',
    perPage: 'per page',
    perPageCount: '{{count}} per page',
    first: 'First',
    previous: 'Previous',
    next: 'Next',
    last: 'Last',
  },

  // Upload
  upload: {
    dragDrop: 'Drag and drop files here',
    or: 'or',
    selectFiles: 'Select Files',
    uploading: 'Uploading...',
    processing: 'Processing...',
    maxSize: 'Max file size: {{size}}',
    allowedTypes: 'Allowed types: {{types}}',
    duplicateCheck: 'Duplicate Check',
    uploadProgress: 'Upload Progress',
    overallProgress: 'Overall Progress',
    currentFile: 'Current File',
    errors: 'Errors',
    // Upload Page specific
    pageTitle: 'Upload Documents',
    selectDocuments: 'Select Documents to Upload',
    selectDocumentsDesc: 'Drag and drop files here or click to browse. Supported formats: PDF, DOCX, XLSX',
    browseFiles: 'Browse Files',
    selectedFiles: 'Selected Files',
    addMetadata: 'Add Document Metadata',
    addMetadataDesc: 'Provide additional information about the documents to improve searchability',
    uploadProgressTitle: 'Upload Progress',
    uploadProgressDesc: 'Your documents are being uploaded and processed',
    uploadComplete: 'Upload Complete!',
    uploadCompleteDesc: '{{completed}} of {{total}} files uploaded successfully.',
    backgroundProcessingTitle: 'Uploaded; AI processing continues',
    backgroundProcessingMessage: 'Uploaded. AI processing is continuing in the background.',
    backgroundProcessingDesc: 'AI processing is continuing in the background. You can check the status later from the document list or detail page.',
    viewDocuments: 'View Documents',
    // Steps
    steps: {
      selectFiles: 'Select Files',
      addMetadata: 'Add Metadata',
      uploadProcess: 'Upload & Process',
    },
    // Duplicate dialog
    duplicateDetected: 'Duplicate File Detected',
    duplicateWarning: 'A file with the same content already exists in the system.',
    duplicateFileName: 'File name: {{name}}',
    duplicatePrompt: 'A document with the same file name already exists. How would you like to handle it?',
    uploadingFile: 'File to upload:',
    existingFileInfo: 'Existing file information:',
    fileName: 'File name',
    fileSize: 'File size',
    title: 'Title',
    currentVersion: 'Current version',
    uploadedAt: 'Uploaded at',
    newVersionInfo: 'Choosing "Save as new version" keeps the existing file and saves the new file as Version {{version}}.',
    duplicateFile: 'File',
    existingDocument: 'Existing Document',
    cancelUpload: 'Cancel Upload',
    uploadAnyway: 'Upload Anyway',
    replaceExisting: 'Replace Existing',
    saveAsSeparate: 'Save as separate file',
    saveAsNewVersion: 'Save as new version',
    // Navigation
    back: 'Back',
    next: 'Next',
    duplicate: 'Duplicate',
    // Dropzone
    dropFilesHere: 'Drop files here',
    dragDropFiles: 'Drag & Drop files here',
    orClickToBrowse: 'or click to browse your computer',
    maxFiles: 'Maximum files: {{count}}',
    maxFilesError: 'Maximum {{count}} files allowed',
    fileSizeError: '{{name}}: File size exceeds {{size}}MB limit',
    fileTypeError: '{{name}}: Unsupported file type. Allowed: {{types}}',
    progressTracker: {
      overallProgress: 'Overall Progress',
      fileProgress: 'File Progress',
      completedCount: '{{count}} Completed',
      failedCount: '{{count}} Failed',
      fileDetails: 'File Details',
      fileSize: 'File Size:',
      fileType: 'File Type:',
      progress: 'Progress:',
      metadata: 'Metadata',
      category: 'Category:',
      description: 'Description:',
    },
    status: {
      pending: 'Waiting...',
      uploading: 'Uploading... {{progress}}%',
      processing: 'Processing...',
      completed: 'Completed',
      error: 'Failed',
      duplicate: 'Duplicate file',
      unknown: 'Unknown',
    },
  },

  testUpload: {
    title: 'Test Data Upload',
    description: 'Bulk upload development and test documents.',
    incidentDirectory: 'Incident file directory: /upload_data/incident file/',
    quickUpload: 'Quick Upload',
    selectIncidentFiles: 'Select incident files and upload',
    quickUploadHelp: 'Metadata is set automatically when you select incident files.',
    detailedUpload: 'Detailed Upload',
    category: 'Category',
    categories: {
      incident: 'Incidents',
      finance: 'Finance',
      planning: 'Planning',
      analytics: 'Analytics',
      engineering: 'Engineering',
    },
    selectFiles: 'Select files',
    selectedFiles: 'Selected files: {{count}}',
    startUpload: 'Start upload',
    uploading: 'Uploading...',
    results: 'Upload Results',
    successCount: 'Succeeded: {{count}}',
    failureCount: 'Failed: {{count}}',
    succeededFiles: 'Succeeded files:',
    failedFiles: 'Failed files:',
    instructionsTitle: 'How to use:',
    instructions: {
      quick: 'Click "Select incident files and upload" to bulk upload incident files.',
      detailed: 'Or use "Detailed Upload" to choose a category and upload files.',
      metadata: 'Metadata is generated automatically from file names for incident files.',
      review: 'After upload, review the files on the documents page.',
    },
  },

  // Search
  search: {
    title: 'Search',
    searchDocuments: 'Search Documents',
    advancedSearch: 'Advanced Search',
    searchResults: 'Search Results',
    noResults: 'No results found',
    errorTitle: 'Search Error',
    searchIn: 'Search in',
    matchType: 'Match Type',
    exactMatch: 'Exact Match',
    fuzzyMatch: 'Fuzzy Match',
    suggestions: 'Suggestions',
    relatedDocuments: 'Related Documents',
    searchHistory: 'Search History',
    savedSearches: 'Saved Searches',
    // Search Page specific
    searchPlaceholder: 'Search for documents, reports, presentations...',
    filters: 'Filters',
    searchType: 'Search Type',
    searchTypes: {
      basic: 'Basic Search',
      semantic: 'Semantic Search',
      exact: 'Exact Match',
    },
    sortOptions: 'Sort Options',
    sortBy: 'Sort By',
    sortValues: {
      relevance: 'Relevance',
      title: 'Title',
    },
    order: 'Order',
    sortOrder: {
      desc: 'Descending',
      asc: 'Ascending',
    },
    active: 'Active',
    activeFilters: 'Active Filters',
    noDocumentsMatch: 'No documents match "{{query}}"',
    adjustTermsOrFilters: 'Try adjusting your search terms or filters',
    resultsSummary: '{{total}} results',
    resultsSummaryForQuery: '{{total}} results for "{{query}}"',
    searchTime: '({{time}}s)',
  },

  integrationNotice: {
    title: 'Azure Integration Status',
    features: {
      authentication: 'Authentication',
      fileUpload: 'File Upload',
      documentSearch: 'Document Search',
      documentList: 'Document List',
      documentDetails: 'Document Details',
    },
    descriptions: {
      authentication: 'Using mock authentication (backend auth not implemented)',
      fileUpload: 'Fully integrated with Azure Document Intelligence',
      documentSearch: 'Fully integrated with Azure AI Search',
      backendPending: 'Backend API not yet available',
    },
    noteLabel: 'Note:',
    note: 'You can test file upload and search functionality. Document listing and details require backend implementation.',
  },

  // Permissions
  permissions: {
    read: 'Read',
    write: 'Write',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    share: 'Share',
    admin: 'Admin',
    owner: 'Owner',
    public: 'Public',
    private: 'Private',
    restricted: 'Restricted',
    loadFailed: 'Failed to load permissions',
    manageDescription: 'Manage who can access this document and what actions they can perform.',
    addPermission: 'Add Permission',
    editPermission: 'Edit Permission',
    noPermissions: 'No permissions set',
    noPermissionsDescription: 'Click "Add Permission" to grant access to users or groups',
    entity: 'Entity',
    type: 'Type',
    grantedBy: 'Granted By',
    grantedDate: 'Granted Date',
    entityType: 'Entity Type',
    selectEntity: 'Select {{type}}',
    readDescription: 'Read - Can view the document',
    writeDescription: 'Write - Can edit the document',
    shareDescription: 'Share - Can share the document with others',
    deleteDescription: 'Delete - Can delete the document',
    types: {
      user: 'User',
      group: 'Group',
      tenant: 'Tenant',
    },
  },

  // Categories (matching database migration 008 codes)
  categories: {
    incident: 'Past Trouble Reports',
    design_standard: 'Design Standards',
    technical_specs: 'Technical Specifications',
    operation_manuals: 'Operation Manuals',
    drawing: 'Technical Drawings',
    planning: 'Planning',
    analytics: 'Analytics',
    other: 'Other',
    incidentDesc: 'Past trouble and failure reports',
    design_standardDesc: 'Design standards and guidelines documents',
    technical_specsDesc: 'Technical specifications and requirements documents',
    operation_manualsDesc: 'System and product operation manuals',
    drawingDesc: 'Technical drawings and design diagrams',
    planningDesc: 'Proposals and planning documents',
    analyticsDesc: 'Analysis reports and research',
    otherDesc: 'Other documents',
  },

  // Document Metadata Form
  metadata: {
    basicInformation: 'Basic Information',
    category: 'Category',
    categoryRequired: 'Category is required',
    description: 'Description',
    descriptionRequired: 'Description is required',
    descriptionHelp: 'Provide a brief description of the document content',
    department: 'Department',
    none: 'None',
    tags: 'Tags',
    tagsPlaceholder: 'Add tags to improve searchability',
    tagsHelp: 'Select from suggestions or type custom tags',
    addCustomTag: 'Add custom tag',
    add: 'Add',
    classificationSecurity: 'Classification & Security',
    classification: 'Classification',
    public: 'Public',
    publicDesc: 'Can be shared outside the organization',
    internal: 'Internal',
    internalDesc: 'For internal use only',
    confidential: 'Confidential',
    confidentialDesc: 'Restricted access required',
    defaultAccessLevel: 'Default Access Level',
    privateOnly: 'Private (Only me)',
    teamDepartment: 'Team (My department)',
    organizationEveryone: 'Organization (Everyone)',
    allowShare: 'Allow others to share this document',
    allowDownload: 'Allow others to download this document',
    continueToUpload: 'Continue to Upload',
    metadataNote: 'This metadata will be applied to all {{count}} selected {{files}}.',
    file: 'file',
    files: 'files',
  },

  // Departments
  departments: {
    finance: 'Finance',
    marketing: 'Marketing',
    engineering: 'Engineering',
    humanResources: 'Human Resources',
    sales: 'Sales',
    operations: 'Operations',
    legal: 'Legal',
    executive: 'Executive',
  },

  // Admin
  admin: {
    title: 'Administration',
    description: 'Manage system settings, users, and monitor activity.',
    users: 'User Management',
    usersDescription: 'Manage users, roles, and permissions',
    groups: 'Group Management',
    categories: 'Category Management',
    tags: 'Tag Management',
    permissions: 'Permission Management',
    auditLogs: 'Audit Logs',
    auditLogsDescription: 'View system audit logs',
    settings: 'System Settings',
    settingsDescription: 'Configure system-wide settings',
    systemHealth: 'System Health',
    storage: 'Storage Management',
    storageDescription: 'Monitor storage usage and quotas',
    security: 'Security',
    securityDescription: 'Security settings and access control',
    analytics: 'Analytics',
    analyticsDescription: 'System usage analytics and reports',
    activityAudit: 'Activity Audit',
    activityAuditDescription: 'Review tenant-wide user activity in the dashboard (#579)',
    anomalies: 'Anomaly Events',
    anomaliesDescription: 'Review suspicious signals such as repeated login failures and cross-tenant access (#578)',
    noPermission: "You don't have permission to access any administrative features.",
  },

  // Settings
  settings: {
    title: 'Settings',
    description: 'Customize application display and notification settings.',
    appearance: 'Appearance',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    language: 'Language Settings',
    selectLanguage: 'Display Language',
    languageOptions: {
      japanese: 'Japanese',
      english: 'English',
    },
    notifications: 'Notification Settings',
    enableNotifications: 'Enable in-app notifications',
    emailNotifications: 'Receive email notifications',
    notificationNote: 'Notification settings are saved in this browser.',
    activityTitle: 'Activity & Audit Logs',
    activityDescription: 'Review tenant activity history such as login, document, chat, CAD, and DRBFM operations (manager or above).',
    openActivityDashboard: 'Open Activity Dashboard',
    openAnomalyTriage: 'Review Anomaly Events',
    systemTitle: 'System Settings',
    systemDescription: 'Manage system settings and administration.',
    searchSettings: 'Search Settings',
    tenantSettingsFetchFailed: 'Failed to fetch tenant settings.',
    keywordMatching: 'Keyword matching processing',
    keywordMatchingTooltip: 'When ON, search queries are preprocessed with synonym expansion and keyword extraction. When OFF, only semantic search (AI meaning understanding) is used.',
    keywordMatchingEnabled: 'Keyword matching has been enabled.',
    keywordMatchingDisabled: 'Keyword matching has been disabled (semantic search only).',
    keywordMatchingEnabledDescription: 'Enabled: preprocesses queries with synonym expansion and keyword extraction',
    keywordMatchingDisabledDescription: 'Disabled: uses semantic search (RAG) only',
    updateFailed: 'Failed to update settings.',
    adminRequired: 'Administrator permission is required to change this setting.',
    searchModesTitle: 'About search modes',
    keywordMatchOnLabel: 'Keyword match ON',
    keywordMatchOnDescription: 'Analyzes the entered query, expands synonyms, and extracts keywords before searching. Suitable for specific terms or product names.',
    keywordMatchOffLabel: 'Keyword match OFF',
    keywordMatchOffDescription: 'AI directly understands the meaning of the search query and performs semantic search. Suitable for natural-language questions.',
    dataManagement: 'Data Management',
    currentStatus: 'Current Status',
    registeredDocuments: '• Registered documents: {{count}}',
    defaultBackup: '• Default backup: {{status}}',
    available: 'Available',
    unavailable: 'Unavailable',
    dataResetTitle: 'About data reset',
    dataResetDescription: 'This restores document metadata to the saved default state. All currently uploaded document information returns to the backed-up state.',
    warningLabel: 'Warning',
    dataResetWarning: 'This operation cannot be undone. Current data will be overwritten by the backed-up state.',
    resetToDefault: 'Reset to default state',
    resetting: 'Resetting...',
    resetComplete: '✓ Reset complete: restored {{count}} documents',
    resetFailed: 'Reset failed',
    resetError: 'Error: {{message}}',
    resetConfirmTitle: 'Confirm Data Reset',
    resetConfirmQuestion: 'Are you sure you want to reset data to the default state?',
    resetConfirmDescription: 'This operation restores the current document metadata to the backed-up state.',
    irreversible: 'This operation cannot be undone.',
    executeReset: 'Run Reset',
  },

  // Audit
  audit: {
    title: 'Activity Audit',
    period: 'Period',
    totalEvents: 'Total Events',
    activeUsers: 'Active Users',
    totalAnomalies: 'Suspicious Actions (Total)',
    unresolvedAnomalies: 'Unresolved Suspicious Actions',
    eventsByCategory: 'Events by Category',
    recentEvents: 'Recent Events',
    categoryAll: 'Category: All',
    time: 'Time',
    action: 'Action',
    result: 'Result',
    user: 'User',
    resource: 'Resource',
    durationMs: 'Duration (ms)',
    noMatchingEvents: 'No matching events',
    summaryFetchFailed: 'Failed to fetch summary: {{message}}',
    eventsFetchFailed: 'Failed to fetch events: {{message}}',
    csvExportFailed: 'CSV export failed: {{message}}',
    results: {
      all: 'All',
      success: 'success',
      failure: 'failure',
      error: 'error',
    },
  },

  // Anomalies
  anomalies: {
    title: 'Anomaly Events',
    severity: 'Severity',
    status: 'Status',
    type: 'Type',
    path: 'Path',
    resolved: 'Resolved',
    unresolved: 'Unresolved',
    markResolved: 'Mark Resolved',
    noMatchingAnomalies: 'No matching anomaly events',
    resolveDialogTitle: 'Mark anomaly as resolved',
    resolveNote: 'Resolution note (optional)',
    totalCount: 'Total {{total}} items',
    fetchFailed: 'Failed to fetch anomaly events: {{message}}',
    resolveFailed: 'Failed to mark resolved: {{message}}',
    severityValues: {
      low: 'low',
      medium: 'medium',
      high: 'high',
      critical: 'critical',
    },
  },

  // CAD Viewer
  cad: {
    title: '3D CAD Viewer',
    prototype: 'Prototype',
    disabled: 'This feature is disabled in the current environment. Please contact an administrator.',
    loadModelsFailed: 'Failed to load the model list',
    comparisonFailed: 'Comparison failed: {{message}}',
    deleteFailed: 'Failed to delete the model',
    drbfmLoading: 'Loading DRBFM results...',
    drbfmLoadFailed: 'Failed to fetch DRBFM results: {{message}}',
    drbfmLinked: 'DRBFM session linked: showing {{shown}} / {{total}} markers',
    drbfmNoMatchingModel: 'No CAD model linked to the DRBFM session is selected ({{total}} markers belong to another model)',
    uploadedModels: 'Uploaded ({{count}})',
    comparisonTarget: 'Comparison target',
    comparing: 'Comparing...',
    startComparison: 'Start comparison',
    comparisonMode: 'Comparison Mode',
    confidenceLabel: 'Confidence: {{value}}',
    exitComparisonMode: 'Exit comparison mode',
    metadataTab: 'Metadata',
    aiAnalysisTab: 'AI Analysis',
    chatTab: 'Chat',
    deleteDialogTitle: 'Delete Model',
    deleteDialogBody: 'Delete this CAD model and all related files?',
    modelList: {
      emptyTitle: 'No models',
      emptyDescription: 'Upload a CAD file',
      setComparisonTarget: 'Set as comparison target',
      delete: 'Delete',
    },
    modelSelect: {
      label: 'CAD Model',
      none: 'Do not select a CAD model',
      empty: 'No analyzed CAD models are available',
      loadFailed: 'Failed to load CAD models',
    },
    upload: {
      dropLabel: 'Drag and drop a CAD file',
      processing: 'Processing... {{progress}}%',
      unsupportedFormat: 'Unsupported file format: {{extension}}\nSupported formats: {{formats}}',
      fileTooLarge: 'File size exceeds 100 MB',
      failed: 'Upload failed',
    },
    viewer: {
      selectModel: 'Select a model.',
      loadFailed: 'Failed to load the 3D model',
      retry: 'Retry',
      loading: 'Loading...',
      hideGrid: 'Hide grid',
      showGrid: 'Show grid',
      showSolid: 'Show solid',
      showWireframe: 'Show wireframe',
      fit: 'Fit',
      reset: 'Reset',
    },
    chat: {
      selectModel: 'Select a model to start chatting',
      guidance: 'Ask about the CAD model',
      sampleSize: 'What is the rough size of this part?',
      sampleManufacturing: 'Suggest a manufacturing method',
      sampleQuality: 'What quality checkpoints matter?',
      placeholder: 'Enter a question...',
      error: 'An error occurred. Please try again.',
      threadCompareTitle: '[3DCAD] Compare: {{modelA}} vs {{modelB}}',
      threadTitle: '[3DCAD] {{model}}',
    },
    ai: {
      selectModel: 'Select a model.',
      title: 'AI Analysis',
      analyzing: 'Analyzing...',
      reanalyze: 'Reanalyze',
      start: 'Start Analysis',
      description: 'Run GPT-4 analysis from design and manufacturing viewpoints.',
      failed: 'AI analysis failed',
    },
    marker: {
      source: {
        pre_label: 'Predefined label',
        hotspot: 'Analysis hotspot',
        llm_inferred: 'LLM inferred',
      },
    },
    markerDetail: {
      title: 'Failure Mode Details',
      noData: 'No DRBFM data is linked to this position.',
      confidence: 'Confidence {{value}}%',
      cause: 'Cause',
      effect: 'Effect',
      part: 'Part',
      locationEvidence: 'Location Link Reason',
      relatedDocuments: 'Related Technical Documents',
    },
    metadata: {
      empty: 'No metadata',
      title: 'Metadata',
      dimensions: 'Dimensions',
      boundingBox: 'Bounding Box',
      volume: 'Volume',
      surfaceArea: 'Surface Area',
      geometry: 'Geometry',
      triangleCount: 'Triangle Count',
      vertexCount: 'Vertex Count',
      edgeCount: 'Edge Count',
      faceCount: 'Face Count',
      file: 'File',
      originalFormat: 'Original Format',
      originalFileSize: 'Original File Size',
      glbSize: 'GLB Size',
      nonWatertightMesh: 'Non-watertight mesh',
      wallThickness: 'Wall Thickness',
      confidence: {
        high: 'High confidence',
        medium: 'Approximate',
        low: 'Low confidence',
      },
      min: 'Min',
      median: 'Median',
      mean: 'Mean',
      max: 'Max',
      thinAreas: 'Thin Areas',
      detectedCount: '{{count}} detected',
      meshQuality: 'Mesh Quality',
      watertight: 'Watertight',
      yes: 'Yes',
      no: 'No',
      bodyCount: 'Body Count',
      degenerateFaces: 'Degenerate Faces',
      draftRisk: 'Draft Risk',
      undercutFraction: 'Undercut Fraction',
      riskRegionCount: 'Risk Region Count',
      count: '{{count}} items',
      pullDirection: 'Pull Direction',
      analysisScope: 'Analysis Scope',
      target: 'Target',
    },
  },

  // DRBFM (Design Review Based on Failure Mode)
  drbfm: {
    title: 'DRBFM Analysis',
    description: 'Perform failure mode analysis based on design changes',
    newAnalysis: 'New Analysis',
    sessionHistory: 'Analysis History',
    // Wizard steps
    steps: {
      input: 'Input',
      processing: 'Processing',
      results: 'Results',
    },
    // Input form
    input: {
      title: 'Analysis Data Input',
      description: 'Enter the item name and the old/new specification content for design change analysis.',
      basicInfo: 'Basic Information',
      itemName: 'Item Name',
      itemNamePlaceholder: 'e.g., Brake Pad, ECU Board',
      itemNameHelper: 'Enter the name of the item to analyze',
      analysisTitle: 'Analysis Title',
      analysisTitlePlaceholder: 'e.g., 2024 Model Specification Change Analysis',
      analysisTitleHelper: 'Optional title for this analysis',
      specifications: 'Specifications',
      specificationsHelp: 'Enter the old and new specification content. You can type directly or load from a file.',
      oldSpecification: 'Old Specification',
      oldSpecPlaceholder: 'Enter old specification content...\n\nExample:\nMaterial: SUS304\nThickness: 2.0mm\nSurface Treatment: None\nTolerance: ±0.1mm',
      newSpecification: 'New Specification',
      newSpecPlaceholder: 'Enter new specification content...\n\nExample:\nMaterial: SUS316L\nThickness: 1.8mm\nSurface Treatment: Ni Plating\nTolerance: ±0.05mm',
      selectDocument: 'Select from Documents',
      loadFromDocument: 'Load from Document',
      startAnalysis: 'Start Analysis',
      starting: 'Starting analysis...',
      analysisInfo: 'AI will compare specifications, extract changes, and perform failure mode analysis. This may take a few minutes.',
      documentMode: 'Document Selection',
      textMode: 'Text Input',
      selectOldSpec: 'Select Old Specification',
      selectNewSpec: 'Select New Specification',
    },
    // Document Selector
    documentSelector: {
      selectDocument: 'Select Document',
      searchPlaceholder: 'Search documents...',
      selected: 'Selected',
      change: 'Change',
      fetchError: 'Failed to fetch document list',
      contentError: 'Failed to retrieve document content',
      noResults: 'No search results',
      noDocuments: 'No documents available',
      loadingContent: 'Loading content...',
      documentSelected: 'Document selected',
    },
    // History Page
    history: {
      title: 'DRBFM Analysis History',
      noSessions: 'No analysis history',
      newAnalysis: 'New Analysis',
      startFirst: 'Start your first analysis',
      columnItem: 'Item',
      columnTitle: 'Title',
      columnAnalysis: 'Analysis Target',
      columnStatus: 'Status',
      columnCreated: 'Created',
      columnCompleted: 'Completed',
      columnActions: 'Actions',
      viewResults: 'View Results',
      view3D: 'View in 3D',
      export: 'Export',
      delete: 'Delete',
      deleteTitle: 'Delete Analysis Results',
      deleteConfirm: 'Are you sure you want to delete the analysis results for "{{itemName}}"? This action cannot be undone.',
      exportError: 'Export failed',
      statusCompleted: 'Completed',
      statusProcessing: 'Processing',
      statusFailed: 'Failed',
      statusDraft: 'Draft',
      preview: 'Preview',
      exportExcel: 'Export Excel',
      previewTitle: 'DRBFM Analysis Results Preview',
      previewFrameTitle: 'DRBFM Preview',
      previewError: 'Failed to load preview',
      resultsFetchFailed: 'Failed to fetch DRBFM results',
    },
    // Processing
    processing: {
      title: 'Analysis in Progress',
      description: 'AI is analyzing the design changes. Please wait for completion.',
      analyzing: 'Analyzing...',
      pleaseWait: 'Please wait',
      overallProgress: 'Overall Progress',
      flowStatus: 'Flow Status',
      progressLog: 'Progress Log',
      creatingSession: 'Creating session...',
      flow1: {
        title: 'Change Extraction',
        description: 'Comparing old and new specifications to extract changes',
      },
      flow2: {
        title: 'Knowledge Base Search',
        description: 'Searching past troubles and design standards for related information',
      },
      flow3: {
        title: 'Failure Mode Analysis',
        description: 'Identifying potential failure modes related to changes',
      },
      flow4: {
        title: 'Countermeasure Generation',
        description: 'Generating effective countermeasures for failure modes',
      },
      flow5: {
        title: 'Report Generation',
        description: 'Generating DRBFM table and report',
      },
      pending: 'Pending',
      inProgress: 'In Progress',
      completed: 'Completed',
      failed: 'Failed',
      cancel: 'Cancel Analysis',
    },
    // Results
    results: {
      title: 'Analysis Results',
      description: 'View detailed DRBFM analysis results.',
      summary: 'Summary',
      designChanges: 'Design Changes',
      failureModes: 'Failure Modes',
      countermeasures: 'Countermeasures',
      exportHTML: 'Export as HTML',
      exportPDF: 'Export as PDF',
      export: 'Export',
      exporting: 'Exporting...',
      newAnalysis: 'New Analysis',
      startNew: 'Start New Analysis',
      backToInput: 'Back to Input',
      noResults: 'No analysis results',
      tabsAria: 'DRBFM results tabs',
    },
    // Export dialog
    export: {
      dialogTitle: 'Export Analysis Results',
      sessionLabel: 'Session',
      selectFormat: 'Select Export Format',
      formatHtml: 'HTML Format',
      formatHtmlDesc: 'HTML file viewable in browser',
      formatPdf: 'PDF Format',
      formatPdfDesc: 'PDF file for printing and sharing',
      formatExcel: 'Excel Format',
      formatExcelDesc: 'Excel file for data analysis',
      exporting: 'Exporting...',
      download: 'Download',
    },
    // Table headers
    table: {
      category: 'Category',
      item: 'Item',
      itemName: 'Item Name',
      oldSpec: 'Old Specification',
      newSpec: 'New Specification',
      specifications: 'Specification Comparison',
      change: 'Change Description',
      changeDescription: 'Change Description',
      impact: 'Impact Areas',
      impactAreas: 'Impact Areas',
      failureMode: 'Failure Mode',
      failureDescription: 'Failure Mode',
      cause: 'Cause',
      failureCause: 'Failure Cause',
      effect: 'Effect',
      failureEffect: 'Failure Effect',
      severity: 'Severity',
      severityScore: 'Score',
      rpn: 'RPN',
      rpnScore: 'RPN',
      countermeasure: 'Countermeasure',
      countermeasureType: 'Type',
      type: 'Type',
      description: 'Description',
      effectiveness: 'Effectiveness',
      priority: 'Priority',
      reference: 'Reference',
      designChanges: 'Design Changes',
      failureModes: 'Failure Modes',
      countermeasures: 'Countermeasures',
      noData: 'No data available',
    },
    // Severity levels
    severity: {
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    // Countermeasure types
    countermeasureType: {
      prevention: 'Prevention',
      detection: 'Detection',
      mitigation: 'Mitigation',
    },
    // Categories
    category: {
      Material: 'Material',
      Dimension: 'Dimension',
      Process: 'Process',
      Structure: 'Structure',
      Surface: 'Surface',
      Tolerance: 'Tolerance',
      Function: 'Function',
      Other: 'Other',
    },
    // Impact areas
    impactArea: {
      Design: 'Design',
      Manufacturing: 'Manufacturing',
      Quality: 'Quality',
      Safety: 'Safety',
      Cost: 'Cost',
      Maintenance: 'Maintenance',
    },
    // Status
    status: {
      draft: 'Draft',
      analyzing: 'Analyzing',
      completed: 'Completed',
      failed: 'Failed',
      pending: 'Pending',
      inProgress: 'In Progress',
    },
    // Session list
    sessions: {
      title: 'Analysis Sessions',
      noSessions: 'No analysis sessions',
      createFirst: 'Start your first analysis',
      loadMore: 'Load More',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this session?',
      view: 'View Details',
      resume: 'Resume',
    },
    // Errors
    errors: {
      createFailed: 'Failed to create session',
      analysisFailed: 'Analysis failed',
      loadFailed: 'Failed to load data',
      exportFailed: 'Export failed',
      connectionLost: 'Connection lost. Please try again.',
      itemNameRequired: 'Item name is required',
      oldSpecRequired: 'Old specification is required',
      newSpecRequired: 'New specification is required',
      sessionLoadFailed: 'Failed to load session',
      cadLinkFailed: 'Failed to link CAD',
    },
    // Success messages
    success: {
      analysisComplete: 'Analysis completed',
      exported: 'Export completed',
      sessionDeleted: 'Session deleted',
    },
    // Knowledge references
    knowledge: {
      title: 'Knowledge References',
      references: 'Related Knowledge',
      document: 'Document',
      relevance: 'Relevance',
      snippet: 'Snippet',
      noReferences: 'No related knowledge found',
    },
    // Statistics
    stats: {
      designChanges: 'Design Changes',
      failureModes: 'Failure Modes',
      countermeasures: 'Countermeasures',
      critical: 'Critical: {{count}}',
      highPriority: 'High Priority: {{count}}',
    },
    // Chat integration
    chat: {
      triggerTitle: 'DRBFM Analysis',
      triggerDescription: 'Start DRBFM analysis from chat. Enter the name of the part to analyze.',
      selectedDocument: 'Selected Document',
      openFullPage: 'Open Full Page',
      startAnalysis: 'Start Analysis',
      resultTitle: 'DRBFM Analysis Results',
      viewDetails: 'View Details',
    },
    // Validation messages
    validation: {
      itemNameRequired: 'Please enter a part name',
    },
    case: {
      title: 'Create GDS Case',
      description: 'Create a DRBFM case from the drawing page and the GDS transfer change summary.',
      startCase: 'Start with GDS Case',
      normalMode: 'Back to Standard DRBFM',
      referenceDrawing: 'Reference drawing: page {{page}}',
      documentId: 'Document ID {{id}}',
      imageId: 'Image ID {{id}}',
      fields: {
        title: 'Case Title',
        productName: 'Product',
        targetPart: 'Target Part',
        changeSummary: 'Change Summary',
      },
      required: '{{field}} is required',
      extractChanges: 'Extract Changes',
      extractingChanges: 'Extracting Changes',
      reviewTitle: 'Review Changes',
      reviewDescription: 'Prepare the extracted technical changes as DRBFM input.',
      noChanges: 'No changes were extracted.',
      changeNumber: 'Change {{number}}',
      confidence: 'Confidence {{value}}%',
      changedItem: 'Changed Item',
      oldSpecification: 'Old Specification',
      newSpecification: 'New Specification',
      technicalChange: 'Technical Change',
      backToConditions: 'Back to Case Conditions',
      generatingPrecheck: 'Generating Precheck',
      continueToPrecheck: 'Continue to Precheck',
      precheckTitle: 'Precheck',
      precheckDescription: 'Clarify unknowns before moving to DRBFM analysis.',
      noPrecheckItems: 'No precheck items.',
      answer: 'Answer',
      answerHelper: 'Typing marks this as answered',
      backToChangeReview: 'Back to Change Review',
      generatingDrbfm: 'Generating DRBFM',
      generateDrbfm: 'Generate DRBFM',
      answerRequired: 'Answer every precheck item or mark it as unknown or not applicable.',
      refetching: 'Refreshing',
      refetchResults: 'Refresh Results',
      analyzingLabel: 'Analyzing DRBFM case',
      exportMissing: 'No DRBFM result is available to export',
      exportFailed: 'Failed to export HTML',
      missingCase: 'Case has not been created.',
      missingAnalysisSession: 'Analysis session has not been created.',
      createCaseFailed: 'Failed to create case.',
      generatePrecheckFailed: 'Failed to generate precheck.',
      fetchResultsFailed: 'Failed to fetch analysis results.',
      analyzeFailed: 'Analysis failed.',
      answerStatus: {
        unanswered: 'Unanswered',
        answered: 'Answered',
        unknown: 'Unknown',
        not_applicable: 'Not applicable',
      },
    },
    drawingEvidence: {
      title: 'Drawing Evidence',
      missingDocumentId: 'Drawing evidence does not include a document ID.',
      imageNotFound: 'No image was found for the target page.',
      imageLoadFailed: 'Failed to load the drawing image.',
      notLinked: 'No drawing evidence is linked yet.',
      openDocumentPage: 'Open document page',
      goToDocument: 'Document',
      missingNormalizedBbox: 'No normalized bbox is available. Check the evidence location on the document page.',
    },
    decisionMemory: {
      title: 'Design Decision Memory',
      selectFailureMode: 'Select a failure mode.',
      severity: 'Severity {{value}}',
      evidenceAvailable: 'Evidence available',
      drawingLinked: 'Drawing linked',
      questionsGenerated: 'Questions generated',
      knowledgeLinked: 'Checked against related knowledge',
      knowledgeUnlinked: 'No related knowledge is linked',
      additionalReviewNeeded: 'Additional review needed',
      noAdditionalQuestions: 'No additional questions',
      reviewComment: 'Review {{description}} as RPN {{rpn}}. {{evidenceText}}, {{questionText}}.',
      followUpQuestions: 'AI Follow-up Questions',
      usedPrecheckAnswers: 'Answers Used in Precheck',
      unresolvedAssumptions: 'Unresolved Assumptions',
      relatedKnowledgeSummary: 'Related Knowledge Summary',
      relevance: 'Relevance {{value}}',
      confidence: 'Confidence {{value}}',
      confirmInDrawing: 'Confirm in Drawing',
    },
    cadLink: {
      parseError: 'Unable to read part-label JSON',
      inputHelper: 'Selecting a CAD model automatically links failure modes to matching 3D locations after DRBFM analysis.',
      partLabelsJson: 'Part-label JSON',
      partLabelsHelper: 'Paste a full cover_part_labels.json file or a parts array to use it as priority labels.',
      bulkView: 'View All in 3D',
      unlinkedCount: '{{count}} failure modes are not linked.',
      partialResolved: 'CAD link partially unresolved: {{linked}} linked, {{unresolved}} unresolved',
      noLinks: 'This DRBFM result has no CAD links yet.',
      linkHelper: 'Link failure modes to the selected CAD model',
      linking: 'Linking...',
      link: 'Link CAD',
      view3DTooltip: 'Show this part in the 3D viewer',
      view3DUnavailable: 'No CAD model is linked or the session ID is missing',
      view3DLabel: 'View in 3D',
      selectFailureModeLabel: 'Select failure mode: {{description}}',
      designChangeExpand: 'Open design-change details',
      designChangeCollapse: 'Close design-change details',
      failureModeExpand: 'Open failure-mode details',
      failureModeCollapse: 'Close failure-mode details',
    },
    // Convert to verification
    convert: {
      dialogTitle: 'Convert to Verification Items',
      buttonLabel: 'Convert to Verification Items',
      steps: {
        selectFailureModes: 'Select Failure Modes',
        chooseTarget: 'Choose Target',
        preview: 'Preview',
      },
      classifications: {
        performance: 'Performance',
        function: 'Function',
        reliability: 'Reliability',
        safety: 'Safety',
        cost: 'Cost',
        maintenance: 'Maintenance',
      },
      methods: {
        analysis: 'Analysis',
        pre_test: 'Pre-test',
        actual_confirm: 'Actual Confirmation',
        dr1: 'DR1',
        design_calc: 'Design Calculation',
        knowhow: 'Know-how',
      },
      fetchSessionsFailed: 'Failed to load verification sessions',
      convertFailed: 'Failed to convert to verification items',
      defaultSessionTitle: 'DRBFM link: {{itemName}}',
      selectFailureModesDescription: 'Select failure modes to convert ({{selected}}/{{total}} selected)',
      selectAll: 'Select All',
      deselectAll: 'Clear All',
      existingSession: 'Add to Existing Session',
      verificationSession: 'Verification Session',
      unit: 'Unit',
      createNewUnit: 'Create New Unit',
      newSession: 'Create New Session',
      sessionTitle: 'Session Title',
      modelName: 'Model Name',
      modelNamePlaceholder: 'e.g., VARIAXIS i-800 NEO',
      unitNumber: 'Unit Number',
      unitName: 'Unit Name',
      previewDescription: 'The following {{count}} verification items will be generated.',
      itemName: 'Item Name',
      classification: 'Classification',
      standardTarget: 'Standard/Target',
      verificationMethod: 'Verification Method',
      destination: 'Destination:',
      destinationNew: 'New session "{{title}}"',
      destinationExisting: 'Existing session "{{title}}"',
      successTitle: 'Added {{count}} verification items',
      successDescription: 'Conversion from DRBFM analysis results is complete.',
      viewVerificationItems: 'View Verification Items',
      back: 'Back',
      next: 'Next',
      submitting: 'Converting...',
      submit: 'Add to Verification Items',
    },
  },

  // Design Verification Items List
  verification: {
    title: 'Design Verification Items',
    description: 'Manage design verification items and export Excel reports',
    units: 'units',
    items: 'items',
    modelName: 'Model Name',
    sessionTitle: 'Session Title',
    sessionDescription: 'Description',
    selectSession: 'Select a session to view',
    noUnits: 'No units yet',
    addUnit: 'Add Unit',
    editUnit: 'Edit Unit',
    deleteUnit: 'Delete Unit',
    addItem: 'Add Item',
    editItem: 'Edit Item',
    unitNumber: 'Unit Number',
    unitNameLabel: 'Unit Name',
    primary: 'Primary',
    secondary: 'Secondary',
    right: 'Right',
    reviewRequired: 'Required',
    reviewNotRequired: 'Not required',
    standardTargetHelp: 'Enter the standard/target value (most critical field)',
    classificationLabels: {
      performance: 'Performance',
      function: 'Function',
      reliability: 'Reliability/Durability',
      safety: 'Safety',
      cost: 'Cost',
      maintenance: 'Maintenance',
    },
    methodLabels: {
      unit_prototype: 'Unit Prototype',
      pre_test: 'Pre-test',
      design_calc: 'Design Calculation',
      competitor_comp: 'Competitor Comparison',
      analysis: 'Analysis',
      dr1: 'DR1',
      knowhow: 'Know-how',
      actual_confirm: 'Actual Confirmation',
    },
    sessionCreated: 'Session created',
    unitAdded: 'Unit added',
    itemAdded: 'Item added',
    deleteConfirmTitle: 'Confirm Deletion',
    deleteConfirmMessage: 'This action cannot be undone. Are you sure you want to delete?',
    chat: {
      title: 'AI Verification Chat',
      openTooltip: 'AI Verification Chat',
      closeTooltip: 'Close chat',
    },
    sessions: {
      title: 'Verification Sessions',
      noSessions: 'No verification sessions',
      create: 'Create New Session',
    },
    table: {
      unit: 'Unit',
      specification: 'Specification',
      itemName: 'Item',
      classification: 'Classification',
      standardTarget: 'Standard/Target',
      verificationMethod: 'Verification Method',
      review: 'Review',
      qualityRecordNo: 'Quality Record No.',
      qualityRecordTitle: 'Quality Record Title',
    },
    export: {
      dialogTitle: 'Export to Excel',
      excel: 'Export Excel',
      sessionLabel: 'Session',
      download: 'Download',
      exporting: 'Exporting...',
      error: 'Export failed',
    },
    drbfmLink: 'This item was generated from DRBFM analysis',
    drbfmLinkTooltip: 'View DRBFM analysis results',
  },

  // Profile
  profile: {
    title: 'Profile',
    userInfo: 'User Information',
    name: 'Name',
    email: 'Email',
    role: 'Role',
    tenant: 'Tenant',
    groups: 'Groups',
    security: 'Security',
    mfa: 'Multi-Factor Authentication (MFA)',
    mfaEnabled: 'Enabled',
    mfaDisabled: 'Disabled',
    lastVerified: 'Last Verified',
    backupCodesRemaining: 'Backup Codes Remaining',
    manageMfa: 'Manage MFA Settings',
    enableMfa: 'Enable MFA',
    mfaNotAvailable: 'MFA information could not be retrieved',
    activeSessions: 'Active Sessions',
    noActiveSessions: 'No active sessions',
    trustedDevices: 'Trusted Devices',
    noTrustedDevices: 'No trusted devices',
    unnamedDevice: 'Unnamed Device',
    sessionDeleted: 'Session deleted successfully',
    deviceRemoved: 'Trusted device removed successfully',
    failedToDelete: 'Failed to delete session',
    failedToRemove: 'Failed to remove trusted device',
    failedToLoadProfile: 'Failed to load profile data',
    deleteSession: 'Delete session',
    removeTrustedDevice: 'Remove trusted device',
  },

  // Chat UI (shared across chat panels)
  chat: {
    addContext: 'Add context',
    attachFile: 'Attach file',
    attachDocument: 'Attach Document',
    allSources: 'AIONA DB',
    allSourcesTooltip: 'Search internal documents only',
    assistant: 'Assistant',
    basedOn: 'Based on:',
    chatTab: 'Chat',
    commands: 'Commands',
    emptyTitle: 'Start the conversation by entering a message below',
    emptyDescription: 'I can help search documents, create summaries, and answer questions',
    enterKey: 'Enter',
    file: 'file',
    files: 'files',
    fileMentionHint: 'Type to search files or use @ to mention',
    fileSearchPlaceholder: 'Search files...',
    filesCount: '{{count}} files',
    filesSelected: '{{count}} selected',
    generateSummary: 'Generate Summary',
    inContext: 'In Context',
    webOnly: 'Web search (pending)',
    webOnlyTooltip: 'Web search is not run yet; answers use internal documents only',
    internalOnly: 'Internal docs only',
    internalOnlyTooltip: 'Search internal documents only',
    messagePlaceholder: 'Type a message...',
    modeSelectorTitle: 'Select mode',
    modeSelectorHint: 'You can also switch with /help, /ask, /plan, or /drbfm',
    newConversation: 'New Conversation',
    noFiles: 'No files',
    noFilesFound: 'No files found',
    openDocument: 'Open document',
    quickActions: 'Quick actions',
    referenceDocuments: 'Reference Documents',
    relevance: 'Relevance',
    relevanceHigh: 'High',
    relevanceMedium: 'Medium',
    relevanceLow: 'Low',
    relatedPassage: 'passage',
    relatedPassages: '{{count}} related passages',
    relatedPassagesUnit: 'passages',
    showRelatedPassages: 'Show {{count}} other related {{unit}} from this file',
    hideRelatedPassages: 'Hide other related passages from this file',
    searchDocuments: 'Search Documents',
    searchResultsCount: '{{count}} results',
    searchedFor: 'Searched for',
    settings: 'Chat settings',
    sourceLabel: 'Source: {{type}}',
    sourceListTitle: '{{title}} ({{count}} {{unit}})',
    sources: 'Sources',
    sourcesTab: 'Sources',
    systemMessage: 'System Message',
    thinking: 'Thinking...',
    stillThinking: 'Still thinking...',
    almostThere: 'Almost there...',
    sendMessage: 'Send message (Enter)',
    inputPlaceholder: 'Ask, search, or make anything...',
    notionEmptyDescription: 'Ask AIONA about documents or get help with writing, analysis, and related work.',
    newChat: 'New Chat',
    newThread: 'New Thread',
    chatFallback: 'Chat',
    modeSwitched: 'Switched to "{{mode}}" mode. {{description}}',
    noFilesSelectedForSummary: 'No files are selected. Select a file and try again.',
    deepAnalysisInProgress: 'Running a detailed technical analysis...',
    fileAnalysisInProgress: 'Analyzing files...',
    summaryUnavailable: 'The summary could not be retrieved.',
    summary: 'summary',
    deepTechnicalAnalysis: 'detailed technical analysis',
    singleFileSummaryHeading: '## {{title}} {{type}}',
    multiFileSummaryHeading: '## {{type}} for selected files ({{count}} files)',
    individualFileSummariesHeading: '### Individual file summaries',
    individualFileAnalysesHeading: '### Individual file technical analyses',
    combinedTechnicalAnalysisHeading: '### Combined technical analysis',
    combinedTechnicalInsightsHeading: '### Combined technical insights',
    summaryError: 'An error occurred while summarizing files. Please try again.',
    askingAboutFiles: '📎 Asking about {{count}} files: {{fileNames}}',
    fileAddedToContext: '✅ Added file to context: {{name}}',
    history: 'Chat history',
    noHistory: 'No chat history',
    pinned: 'Pinned',
    recentChats: 'Recent chats',
    pinThread: 'Pin',
    unpinThread: 'Unpin',
    pinThreadAria: 'Pin {{title}}',
    unpinThreadAria: 'Unpin {{title}}',
    verificationBasedOnDocuments: 'Based on documents',
    verificationPartlyUnsupported: 'Partly unsupported',
    verificationNeedsReviewLabel: 'Needs review',
    verificationDetailsTitle: 'Answer grounding check',
    verificationDetailsDescription: 'Highlighted parts in the answer show verification results. Green means the statement is supported by documents, and orange means support could not be confirmed.',
    verificationSupportedClaims: 'Supported by documents (green): {{count}} sentences',
    verificationUnsupportedClaims: 'Unsupported (orange): {{count}} sentences',
    verificationWeakCitations: 'Low-relevance references: {{count}} items',
    verificationSupportedTitle: 'Supported by documents',
    verificationUnsupportedTitle: 'Unsupported',
    generalFallbackWarning: 'This answer is not based on knowledge-base documents. Please verify its accuracy because it uses general knowledge.',
    verificationNeedsReview: 'Some grounding needs review. Open the answer grounding check above for details.',
    retryWithMode: 'Retry in another mode →',
    deleteConfirm: 'Are you sure you want to delete this document? This action cannot be undone.',
    editTags: 'Edit tags',
    tagInputPlaceholder: 'Type a tag and press Enter',
    viewSource: 'View source',
    modes: {
      help: {
        name: 'Help',
        description: 'System usage and command list',
      },
      settings: {
        name: 'Settings',
        description: 'Data source status and usage statistics',
      },
      ask: {
        name: 'Q&A',
        description: 'Question answering mode (default)',
      },
      plan: {
        name: 'Design Deep Dive',
        description: 'Deep discussion about design',
      },
      drbfm: {
        name: 'DRBFM Analysis',
        description: 'DRBFM analysis support',
      },
      verification: {
        name: 'Design Verification',
        description: 'Analyze and improve design verification items',
      },
      cad: {
        name: 'CAD Analysis',
        description: 'CAD data structure and design review',
      },
    },
  },
};

export default enTranslations;
